
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import BackIcon from '@components/icons/icon-back.svg';
import CloseIcon from '@components/icons/icon-close-solid.svg';

@Component({
  name: 'AppSetupHeader',
  components: {
    BackIcon,
    CloseIcon
  }
})
export default class AppSetupHeader extends Vue {
  @Prop()
  private title: string;

  get step() {
    if (!this.$route.query.step) {
      return 0;
    }
    return parseInt(this.$route.query.step as string);
  }

  get backLocation() {
    if (this.step > 0) {
      return { query: { step: this.step - 1 } };
    }
    return { name: 'myTrips' };
  }
}
